import React, { useState, useEffect, useRef } from 'react';
import './customselectinput.scss';
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";

const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
};

const CustomSelectInput = ({ title, data, onSelect }) => {
    const [isListOpen, setIsListOpen] = useState(false);
    const [selectedOption, setSelected] = useState('Select');
    const ref = useRef(null);

    useClickOutside(ref, () => setIsListOpen(false)); 

    const toggleOptionsList = () => {
        setIsListOpen(prevState => !prevState);
    };

    const handleInputSelection = (value) => {
        setSelected(value);
        onSelect(value); 
        setIsListOpen(false);

        console.log("Selected Data: ", value);

    };

    return (
        <div className='customSelectInputCont' ref={ref}>
            <div className="fieldHeader"
                onClick={toggleOptionsList}
                role="button"
                aria-haspopup="true"
                aria-expanded={isListOpen}>
                <h4
                    className='fieldHeading'
                >
                    {title && selectedOption === 'Select' ? title : selectedOption}
                </h4>
                <div className={`icon ${isListOpen && 'rotateIcon'}`}>
                    <FaAngleDown />
                </div>
            </div>

            {isListOpen && (
                <ul className='optionsList'>
                    {data.map((option, index) => (
                        <li
                            key={index}
                            className="option"
                            onClick={() => handleInputSelection(option)}
                        >
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomSelectInput;
